module.exports = __webpack_public_path__ + "img/region_new_york.b2184757.svg";